// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fE0p9","colBig":"styles_colBig__kztz8","colSmall":"styles_colSmall__Ek5_6"};